import { createRoute, type AnyRoute } from '@tanstack/react-router';
import { PROMPT_LIBRARY_NAV } from './navigation';
import { PromptLibraryPage } from './pages/PromptLibraryPage';

export function createPromptLibraryRoutes<TRootRoute extends AnyRoute>(rootRoute: TRootRoute) {
  const promptLibraryRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: PROMPT_LIBRARY_NAV.path,
    component: PromptLibraryPage,
  });

  const promptLibraryDetailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: `${PROMPT_LIBRARY_NAV.path}/$promptId`,
    component: PromptLibraryPage,
  });

  return {
    promptLibraryDetailRoute,
    promptLibraryRoute,
  };
}
